export default [
    {
        path: 'relatorio-bpa-consolidado',
        component: () => import(
            /* webpackChunkName: 'bpa-relatorio-bpa-consolidado' */
            '@/views/bpa/relatorio-bpa-consolidado/Index'
        ),
        redirect: 'relatorio-bpa-consolidado/index',
        children: [
            {
                name: 'bpa-relatorio-bpa-consolidado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'bpa-relatorio-bpa-consolidado' */
                    '@/views/bpa/relatorio-bpa-consolidado/List.vue'
                ),
            },
        ],
    },
]